import axios from "axios";
import { nyonyaaAdminEndpoint } from "../../../utils";

const authHeader = () => {
  const session = JSON.parse(localStorage.getItem("session_user"));
  return {
    "Content-Type": "application/json",
    authorization: `Bearer ${session.data.jwt}`,
  };
};

// Semua endpoint sustainability membalas {message, time, data}. Helper di bawah
// selalu mengembalikan res.data utuh supaya halaman bisa membaca `message`
// (dipakai untuk notifikasi) maupun `data.masalah` (dipakai untuk daftar error validasi).
export const getSustainability = (payload) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(nyonyaaAdminEndpoint + payload.url, {
        headers: authHeader(),
        params: payload.data,
      })
      .then((res) => {
        if (res.status === 200 && payload.type !== undefined) {
          dispatch({ type: payload.type, payload: res.data.data });
        }
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export const postSustainability = (payload) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: nyonyaaAdminEndpoint + payload.url,
      headers: authHeader(),
      data: payload.data,
    })
      .then((res) => {
        if (payload.type !== undefined) {
          dispatch({ type: payload.type, payload: res.data.data });
        }
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export const putSustainability = (payload) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: nyonyaaAdminEndpoint + payload.url,
      headers: authHeader(),
      data: payload.data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deleteSustainability = (payload) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "delete",
      url: nyonyaaAdminEndpoint + payload.url,
      headers: authHeader(),
      data: payload.data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Backend menolak payload yang tidak lengkap dengan mengirim data.masalah berupa
// array string. Semua pesan harus ditampilkan, bukan hanya yang pertama, karena
// satu form bisa punya beberapa field wajib yang kosong sekaligus.
export const bacaMasalah = (err) => {
  const data = err?.response?.data;
  if (!data) return ["Tidak dapat menghubungi server."];
  if (Array.isArray(data?.data?.masalah) && data.data.masalah.length > 0) {
    return data.data.masalah;
  }
  if (Array.isArray(data?.masalah) && data.masalah.length > 0) {
    return data.masalah;
  }
  return [data.message || "Terjadi kesalahan."];
};

/* ---------- Indicator Settings ---------- */

export const getIndikatorList = (status, kategori) =>
  getSustainability({
    url: "/api/indicators",
    data: { status: status || "", kategori: kategori || "" },
    type: "INDIKATOR_LIST",
  });

export const getIndikatorDetail = (id) =>
  getSustainability({ url: `/api/indicators/${id}`, type: "INDIKATOR_DETAIL" });

export const getFormulaVariables = () =>
  getSustainability({
    url: "/api/indicators/formula-variables",
    type: "FORMULA_VARIABLES",
  });

export const simpanIndikator = (data) =>
  postSustainability({ url: "/api/indicators", data });

export const ubahIndikator = (id, data) =>
  putSustainability({ url: `/api/indicators/${id}`, data });

export const validasiIndikator = (id) =>
  postSustainability({ url: `/api/indicators/${id}/validate`, data: {} });

export const dryRunIndikator = (id, hari) =>
  postSustainability({
    url: `/api/indicators/${id}/dry-run`,
    data: { hari: hari || 30 },
  });

// Validate menerima body berisi calon perubahan sehingga draft bisa diperiksa
// sebelum disimpan.
export const validasiDraftIndikator = (id, data) =>
  postSustainability({ url: `/api/indicators/${id}/validate`, data });

export const publishIndikator = (id, data) =>
  postSustainability({ url: `/api/indicators/${id}/publish`, data });

export const archiveIndikator = (id, alasan) =>
  postSustainability({ url: `/api/indicators/${id}/archive`, data: { alasan } });

export const getBaselineList = (indicatorCode, status) =>
  getSustainability({
    url: "/api/baselines",
    data: { indicator_code: indicatorCode || "", status: status || "" },
    type: "BASELINE_LIST",
  });

export const simpanBaseline = (data) =>
  postSustainability({ url: "/api/baselines", data });

export const getFactorList = (scope, status) =>
  getSustainability({
    url: "/api/factors",
    data: { scope: scope || "", status: status || "" },
    type: "FACTOR_LIST",
  });

export const simpanFactor = (data) =>
  postSustainability({ url: "/api/factors", data });

export const getEquivalenceList = () =>
  getSustainability({ url: "/api/equivalences", type: "EQUIVALENCE_LIST" });

export const simpanEquivalence = (data) =>
  postSustainability({ url: "/api/equivalences", data });

export const ubahEquivalence = (id, data) =>
  putSustainability({ url: `/api/equivalences/${id}`, data });

export const hapusEquivalence = (id) =>
  deleteSustainability({ url: `/api/equivalences/${id}` });

/* ---------- Sustainability Dashboard ---------- */

export const getDashboard = (periode, scope) =>
  getSustainability({
    url: "/api/sustainability/dashboard",
    data: { periode, scope: scope || "company" },
    type: "SUSTAIN_DASHBOARD",
  });

export const getTren = (periodeCount, indicatorCode, periode, scope) =>
  getSustainability({
    url: "/api/sustainability/dashboard/tren",
    data: {
      periode_count: periodeCount || 12,
      indicator_code: indicatorCode || "",
      periode,
      scope: scope || "company",
    },
    type: "SUSTAIN_TREN",
  });

export const getEfisiensi = (periode) =>
  getSustainability({
    url: "/api/sustainability/dashboard/efisiensi",
    data: { periode },
    type: "SUSTAIN_EFISIENSI",
  });

export const getKualitasData = (periode) =>
  getSustainability({
    url: "/api/sustainability/dashboard/kualitas-data",
    data: { periode },
    type: "SUSTAIN_KUALITAS",
  });

export const getBreakdown = (periode, by) =>
  getSustainability({
    url: "/api/impact/breakdown",
    data: { periode, by },
    type: "SUSTAIN_BREAKDOWN",
  });

export const getImpactPeriode = (periode, scope) =>
  getSustainability({
    url: `/api/impact/periods/${periode}`,
    data: { scope: scope || "company" },
    type: "SUSTAIN_IMPACT_PERIODE",
  });

// Endpoint ini mengembalikan daftar beberapa periode terakhir, bukan satu baris,
// jadi halaman yang menyaring periode aktifnya sendiri.
export const getHrPeriod = (limit) =>
  getSustainability({
    url: "/api/impact/hr-period",
    data: { limit: limit || 12 },
    type: "SUSTAIN_HR_PERIOD",
  });

export const simpanHrPeriod = (data) =>
  postSustainability({ url: "/api/impact/hr-period", data });
